import { Directive } from '@angular/core';

@Directive({
    selector: 'app-form-field-hint',
    standalone: false,
})
export class FormFieldHintDirective {
}
